import { render, staticRenderFns } from "./ImportStatusReasonsModal.vue?vue&type=template&id=4636148a&"
import script from "./ImportStatusReasonsModal.vue?vue&type=script&lang=ts&"
export * from "./ImportStatusReasonsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports